module.exports = __webpack_public_path__ + "img/file.c0e803a0.png";